import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { createSelector } from 'reselect';
import { toggleFeedConnectionModal } from '../../../../../../../slices/modals/reducer';
import { Input } from "reactstrap";
import FolderItem from '../../../../../../Folder/FolderItem';
import { formatDate } from '../../../../../../../slices/helper.js';
import { getFolderInFolderThunk, getFolderRootThunk, setFolderHistory } from '../../../../../../../slices/folder/thunk';
import { getFeeds, getFeedsByPage } from '../../../../../../../slices/feeds/thunk';
import { setFolderPath } from '../../../../../../../slices/auth/menu/reducer';
import { getFeedSuccess, setFeedsFirstLoad, setFeedsHasMore, setFeedsLoading, setFeedsPage, setQuery } from '../../../../../../../slices/feeds/reducer';
import Preloader from '../../../../../../../Components/Common/Preloader';
import { setCampaignLoader, setConnectedFeed, setSelectedFeedConnection } from '../../../../../../../slices/campaigns/reducer';
import { connectFeed, disconnectFeed } from '../../../../../../../slices/campaigns/thunk';
import { setPreloader } from '../../../../../../../slices/layouts/reducer';
import { replace } from 'redux-first-history';


function FeedConnection() {
  const dispatch = useDispatch();

  const selectStates = createSelector(state => state, state => ({
    modalState: state.Modal.feedConnectionModal,
    feedConnectionLoader: state.Modal.feedConnectionLoader,
    feeds: state.Feed.feeds,
    feedsLoading: state.Feed.feedsLoading,
    feedsHasMore: state.Feed.feedsHasMore,
    feedsFirstLoad: state.Feed.feedsFirstLoad,
    feedsShowLoader: state.Feed.feedsShowLoader,
    feedsPage: state.Feed.feedsPage,
    folderRootPath: state.Folder.folderRootPath,
    folderHistory: state.Folder.folderHistory,
    selectedFeedConnection: state.Campaign.selectedFeedConnection,
    currentVersion: state.Campaign.currentVersion,
    connectedFeed: state.Campaign.connectedFeed,
    connectedFeedName: state.Campaign.connectedFeedName,
    allLibraries: state.Campaign.allLibraries,
    allLibrariesHasMore: state.Campaign.allLibrariesHasMore,
    allLibrariesPage: state.Campaign.allLibrariesPage,
    currentCampaign: state.Campaign.currentCampaign,
    versions: state.Campaign.versions,
    facebookProperties: state.Campaign.facebookProperties,
    isFacebookPropertiesSet: state.Campaign.isFacebookPropertiesSet,
    dynamicText: state.Campaign.dynamicText,
    activeDynamicText: state.Campaign.activeDynamicText,
    creatives: state.Campaign.creatives,
    uploadLimits: state.Upload.uploadLimits,
    title: state.MenuData.title
  }));
  const {
    modalState,
    feedConnectionLoader,
    feeds,
    feedsLoading,
    feedsHasMore,
    feedsFirstLoad,
    feedsShowLoader,
    feedsPage,
    folderRootPath,
    folderHistory,
    selectedFeedConnection,
    currentVersion,
    connectedFeed,
    connectedFeedName,
    allLibraries,
    allLibrariesHasMore,
    allLibrariesPage,
    currentCampaign,
    versions,
    facebookProperties,
    isFacebookPropertiesSet,
    dynamicText,
    activeDynamicText,
    creatives,
    uploadLimits,
    title
  } = useSelector(selectStates);

  const [feedsState, setFeedsState] = useState([]);

  useEffect(() => {
    dispatch(setFolderHistory([{ name: "Ad Sets" }]))
  }, []);

  async function openSubFolder(item, history = null) {
    if (history) {
      dispatch(setFolderHistory([...history, item]));
      dispatch(setFolderPath(item._id));
    } else {
      dispatch(setFolderHistory([...folderHistory, item]));
      dispatch(setFolderPath(item._id))
    }
    dispatch(getFeedSuccess(null));
    dispatch(setFeedsLoading(false));
    dispatch(setFeedsHasMore(true));
    dispatch(setFeedsFirstLoad(false));
    dispatch(setFeedsPage(1));
    await dispatch(getFeeds(true));
  }

  async function handleHistory(item, idx) {
    if (item.hasOwnProperty("_id")) {
      dispatch(setFolderHistory(folderHistory.slice(0, idx))).then(res => {
        openSubFolder(item, res.payload);
      });
    } else {
      dispatch(setFolderHistory([folderHistory[0]]));
      dispatch(setFolderPath(null));
      dispatch(getFeedSuccess(null));
      dispatch(setFeedsLoading(false));
      dispatch(setFeedsHasMore(true));
      dispatch(setFeedsFirstLoad(false));
      dispatch(setFeedsPage(1));
      dispatch(getFeeds());
    }
  }

  let typingTimer;
  let doneTypingInterval = 500;
  async function handleSearch(e) {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      if (e.target.value === "" || e.target.value === " ") {
        dispatch(setQuery(null));
      } else {
        dispatch(setQuery(e.target.value));
      }
      dispatch(getFeedSuccess(null));
      dispatch(setFeedsLoading(false));
      dispatch(setFeedsHasMore(true));
      dispatch(setFeedsFirstLoad(false));
      dispatch(setFeedsPage(1));
      const res = await dispatch(getFeeds());
      dispatch(getFeedSuccess(res.payload));
    }, doneTypingInterval);
  }


  async function onConnect() {
    dispatch(setCampaignLoader(true));
    await dispatch(connectFeed());
    dispatch(setCampaignLoader(false));
  }

  async function onDisconnect() {
    dispatch(setCampaignLoader(true));
    const { activeDynamicText, dynamicText } = await dispatch(disconnectFeed());
    dispatch(replace(window.location.href, {
      campaigns: allLibraries,
      hasMore: allLibrariesHasMore,
      firstLoad: false,
      campaignPage: allLibrariesPage,
      isLoading: false,
      showLoader: false,
      currentCampaign: currentCampaign,
      versions: versions.map(item => {
        if (item._id === currentVersion._id) {
          return { ...item, feeds: null }
        } else {
          return item;
        }
      }),
      currentVersion: { ...currentVersion, feeds: null },
      facebookProperties: facebookProperties,
      isFacebookPropertiesSet: isFacebookPropertiesSet,
      connectedFeed: null,
      connectedFeedName: null,
      dynamicText: dynamicText,
      activeDynamicText: activeDynamicText,
      fontRes: '',
      previewFonts: '',
      creatives: creatives.map(item => {
        let returnObj = {};
        let keys = Object.keys(item);
        keys.forEach(key => {
          if (key !== 'preview') {
            returnObj[key] = item[key];
          }
        });
        return returnObj;
      }),
      uploadLimits: uploadLimits,
      title: title
    }))
    dispatch(setCampaignLoader(false));
  }

  const fetchFeed = useCallback(async (pageNum, tableData) => {
    dispatch(setFeedsLoading(true));
    try {
      const resData = await dispatch(getFeedsByPage(pageNum));
      if (resData.payload.length === 0) {
        dispatch(setFeedsHasMore(false));
        return;
      }
      const feedsVar = [...feeds, ...resData.payload];
      dispatch(getFeedSuccess(feedsVar));
    } catch (error) {
      // console.log(error);
    } finally {
      dispatch(setFeedsLoading(false));
    }
  }, []);

  let scrollTimeout;
  useEffect(() => {
    async function handleScroll() {
      if (scrollTimeout) clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(async () => {
        const scrollableHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const currentScroll = window.scrollY;

        if (currentScroll >= scrollableHeight - 100) {
          if (!feedsLoading && feedsHasMore) {
            await fetchFeed(feedsPage, (feeds ? feeds : []));
            dispatch(setFeedsPage(feedsPage + 1));
          }
        }
      }, 100);
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [fetchFeed, feedsHasMore, feedsLoading, feedsPage, feeds]);

  return (
    <Modal isOpen={modalState} toggle={() => dispatch(toggleFeedConnectionModal())} centered size='md'>
      <ModalHeader className='p-3' toggle={() => dispatch(toggleFeedConnectionModal())}>
        Select Feed
      </ModalHeader>
      <ModalBody className='px-0 pt-0'>
        {feedConnectionLoader ?
          <Preloader isComponentLoader={true} />
          :
          <React.Fragment>
            {connectedFeedName ?
              <div className='w-100 py-2 px-3 d-flex align-items-center justify-content-between border-bottom'>
                <div className={`w-100 d-flex align-items-center justify-content-between fs-14 user-select-none`}
                  style={{ height: "56px" }}>
                  <div className="d-flex align-items-center gap-1 flex-grow-1 text-truncate">
                    <span class="avatar-title rounded bg-info-subtle text-info fs-3" style={{ width: "32px", height: "32px" }}>
                      <i class="mdi mdi-rss"></i>
                    </span>
                    <p className="m-0 flex-grow-1 text-truncate text-select-0">{connectedFeedName}</p>
                    <button className='btn btn-danger' onClick={onDisconnect}>
                      Disconnect
                      <i className='mdi mdi-link-off ms-1 align-bottom'></i>
                    </button>
                  </div>
                </div>
              </div>
              : null}
            <div className='py-1 px-3 border-bottom'>
              <div className='form-icon'>
                <Input type='text' className='form-control form-control-icon' placeholder='Search feeds' onKeyUp={handleSearch} />
                <i className='ri ri-search-line'></i>
              </div>
            </div>
            {folderHistory.length > 1 ?
              <div className='w-100 pt-3 pb-1 px-3 d-flex align-items-center flex-wrap user-select-none'>
                {(folderHistory || []).map((item, idx) => {
                  let lastItemIdx = folderHistory.length - 1;
                  return (
                    <React.Fragment key={idx}>
                      <p className={'m-0 cursor-pointer' + (idx === lastItemIdx ? ' text-muted fw-bold' : ' ')}
                        onClick={() => handleHistory(item, idx)}>{item.name}</p>
                      {idx !== lastItemIdx ?
                        <i className='ri-arrow-right-s-line align-center fs-4 text-muted mx-2'></i>
                        : null}
                    </React.Fragment>
                  )
                })}
              </div>
              : null}
            <div className='w-100 py-2 px-3 d-flex align-items-center justify-content-between border-bottom text-muted'>
              <p className='m-0'>Name</p>
              <p className='m-0'>Modified</p>
            </div>
            {feeds ? (feeds ? feeds : []).map((item, idx) => {
              if (item.isFolder) {
                return (
                  <FolderItem key={idx} name={item.name} date={item.modifiedDate} handleClick={() => openSubFolder(item)} />
                )
              } else if (item._id !== (currentVersion.hasOwnProperty('feeds') && Array.isArray(currentVersion?.feeds) ? currentVersion?.feeds[0] : '')) {
                return (
                  <div className={`w-100 py-1 px-3 d-flex align-items-center justify-content-between
                border-bottom cursor-pointer fs-14 user-select-none hover-bg-light` + (selectedFeedConnection ? selectedFeedConnection._id === item._id && " selected-feed-connection" : "")}
                    style={{ height: "56px" }}
                    onClick={() => dispatch(setSelectedFeedConnection(item))}>
                    <div className="d-flex align-items-center gap-1 flex-grow-1 text-truncate">
                      <span class="avatar-title rounded bg-info-subtle text-info fs-3" style={{ width: "32px", height: "32px" }}>
                        <i class="mdi mdi-rss"></i>
                      </span>
                      <p className="m-0 flex-grow-1 text-truncate text-select-0">{item.name}</p>
                    </div>
                    <p className='m-0 ms-3 text-nowrap'>{formatDate(item.modifiedDate)}</p>
                  </div>
                )
              }
            }) : null}
          </React.Fragment>
        }
      </ModalBody>
      <ModalFooter>
        {/* <button className='btn btn-info'>
          Load More
        </button> */}
        {selectedFeedConnection ?
          <button className='btn btn-success' onClick={onConnect}>
            Connect Feed
          </button>
          : null}
        <button className='btn btn-light' onClick={() => dispatch(toggleFeedConnectionModal())}>
          Close
        </button>
      </ModalFooter>
    </Modal>
  )
}

export default FeedConnection
